import { FETCH_EMPLOYEES_SUCCESS, FETCH_EMPLOYEE_SUCCESS } from "../../constants/ActionTypes";

const initialSettings = {};

export default (state = initialSettings, action) => {
	switch (action.type) {
		case FETCH_EMPLOYEES_SUCCESS: {
			return { ...state, index: action.payload };
		}
		case FETCH_EMPLOYEE_SUCCESS: {
			return { ...state, show: action.payload };
		}
		default:
			return state;
	}
};
